import { supabase } from './supabase';
import type { XmCustomer, XmCustomerPayment, XmCardBrand } from '../types/database';

export async function getXmCustomers(businessId: string, monthYear: string): Promise<XmCustomer[]> {
  const { data, error } = await supabase
    .from('xm_customers')
    .select('*')
    .eq('business_id', businessId)
    .eq('month_year', monthYear)
    .order('created_at', { ascending: false });

  if (error) throw error;
  return data || [];
}

export async function createXmCustomer(businessId: string, name: string, monthYear: string): Promise<XmCustomer> {
  const { data, error } = await supabase
    .from('xm_customers')
    .insert({ business_id: businessId, name, month_year: monthYear })
    .select()
    .single();

  if (error) throw error;
  return data;
}

export async function deleteXmCustomer(customerId: string): Promise<void> {
  const { error } = await supabase
    .from('xm_customers')
    .delete()
    .eq('id', customerId);

  if (error) throw error;
}

export async function getXmPayments(
  businessId: string,
  monthYear: string
): Promise<XmCustomerPayment[]> {
  const { data, error } = await supabase
    .from('xm_customer_payments')
    .select('*')
    .eq('business_id', businessId)
    .eq('month_year', monthYear)
    .order('payment_date', { ascending: false });

  if (error) throw error;
  return data || [];
}

export async function createXmPayment(
  businessId: string,
  customerId: string,
  monthYear: string,
  cardBrand: XmCardBrand,
  chargedAmount: number,
  fullLimit: number,
  paymentDate?: string
): Promise<XmCustomerPayment> {
  const { data, error } = await supabase
    .from('xm_customer_payments')
    .insert({
      business_id: businessId,
      customer_id: customerId,
      month_year: monthYear,
      card_brand: cardBrand,
      charged_amount: chargedAmount,
      full_limit: fullLimit,
      ...(paymentDate ? { payment_date: paymentDate } : {}),
    })
    .select()
    .single();

  if (error) throw error;
  return data;
}

export async function deleteXmPayment(paymentId: string): Promise<void> {
  const { error } = await supabase
    .from('xm_customer_payments')
    .delete()
    .eq('id', paymentId);

  if (error) throw error;
}

let customerChannelId = 0;
export function subscribeToXmCustomers(
  businessId: string,
  callback: () => void
) {
  return supabase
    .channel(`xm_customers_changes_${++customerChannelId}`)
    .on(
      'postgres_changes',
      { event: '*', schema: 'public', table: 'xm_customers', filter: `business_id=eq.${businessId}` },
      callback
    )
    .subscribe();
}

let paymentChannelId = 0;
export function subscribeToXmPayments(
  businessId: string,
  callback: () => void
) {
  return supabase
    .channel(`xm_payments_changes_${++paymentChannelId}`)
    .on(
      'postgres_changes',
      { event: '*', schema: 'public', table: 'xm_customer_payments', filter: `business_id=eq.${businessId}` },
      callback
    )
    .subscribe();
}
